import React from 'react'

export default function BulletList({ children }) {
  return <ul style={{ paddingInlineStart: 26 }}>{children}</ul>
}
